export * from './customerProject.service';
import { CustomerProjectService } from './customerProject.service';
export * from './customerProject.serviceInterface';
export const APIS = [CustomerProjectService];
